export function getRandomBrightColor() {
  return 'hsla(' + (Math.random() * 360) + ', 100%, 70%, 1)';
}
